import { createContext, useCallback, useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLegalPage, fetchSettings, sendContactMessage } from "../store/common-slice";


const CommonContext = createContext(undefined);

export const CommonProvider = ({ children }) => {
	const {settings,legalData} = useSelector(state=> state.seoSetting);
	const dispatch = useDispatch();
	useEffect(()=>{
		dispatch(fetchSettings());
	},[dispatch])
	const fetchLegalData = useCallback((type = "privacy")=>{
		dispatch(fetchLegalPage(type));
	},[])
	const submitContactMessage = useCallback((formData)=>{
		dispatch(sendContactMessage(formData));
	},[])
	return (
		<CommonContext.Provider value={{ settings, legalData, fetchLegalData, submitContactMessage }}>
			{children}
		</CommonContext.Provider>
	);
};

export const useCommon = () => {
	const context = useContext(CommonContext);
	if (context === undefined) {
		throw new Error("useCommon must be used within a CommonProvider");
	}
	return context;
}